<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
						<!-- <el-form-item :label="$t('userList.userName')" class="mb-0">
							<el-input size="small" v-model="from.name" ></el-input>
						</el-form-item> -->
						<!-- <el-form-item :label="$t('adminList.loginName')" class="mb-0">
							<el-input size="small" v-model="from.username"></el-input>
						</el-form-item> -->
						<!-- <el-form-item :label="$t('accountList.isFp')" class="mb-0">
							<el-select v-model="from.status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('accountList.yes')" :value="1"></el-option>
								<el-option :label="$t('accountList.no')" :value="0"></el-option>
							</el-select>
						</el-form-item> -->
						
						<el-form-item :label="$t('acapplyList.status')" class="mb-0">
							<el-select v-model="from.status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('acapplyList.dai')" :value="0"></el-option>
								<el-option :label="$t('acapplyList.yes')" :value="1"></el-option>
								<el-option :label="$t('acapplyList.no')" :value="2"></el-option>
								<el-option :label="$t('acapplyList.close')" :value="3"></el-option>
								
							</el-select>
						</el-form-item>
						<!-- <el-form-item :label="$t('accountList.cloudName')" class="mb-0">
							<el-select v-model="from.cloud_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option  :label="$t('status.all')" :value="-1">
								</el-option>
								<el-option v-for="item in agentData.cloud" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item> -->
						
						<el-form-item :label="$t('acapplyList.time')"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
							      >
							    </el-date-picker>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
						</el-form-item>
				
					</el-form>
					<!-- <div style="margin-top:10px">
						<el-button size="small" @click="openModel(false)" v-auth="'add'+auth_val" >{{$t('accountList.addAccount')}}</el-button>
					</div> -->
			</template>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2" style="padding-bottom:20px">
			<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				<!-- <el-table-column align="center" type="index" :label="$t('adminList.sort')" width="50">
				</el-table-column> -->
				
				<el-table-column fixed="left" align="center" prop="id"  :label="$t('userList.id')" width="60">
				</el-table-column>
				<!-- <el-table-column align="center" prop="name" width="50" :label="$t('adminList.avatar')">
					<template slot-scope="scope">
						<el-image 
							style="width: 40px; height: 40px"
							:src="scope.row.head" 
							:preview-src-list="check_img_list">
						</el-image>
					</template>
				</el-table-column> -->
				
				<!-- <el-table-column width="100" align="center" prop="cloud_name" :label="$t('accountList.cloudName')">
				</el-table-column> -->
				
				<el-table-column align="center" width="140" prop="user_name" :label="$t('acapplyList.user')">
					<template slot-scope="scope">
						<el-link @click="layout.openUserInfo(scope.row.uid)" type="primary" class="text_chengse">{{scope.row.user_name}}</el-link>
						
					</template>
				</el-table-column>
				
				<el-table-column align="center" width="140" prop="apply_title" :label="$t('acapplyList.title')">
				</el-table-column>
				
				
				
				<el-table-column align="center" prop="get_status" :label="$t('acapplyList.status')">
					<template slot-scope="scope">
						<span  v-if="scope.row.status==0">{{$t('acapplyList.dai')}}</span>
						<span class="text-success" v-if="scope.row.status==1">{{$t('acapplyList.yes')}}</span>
						<span class="text-danger" v-if="scope.row.status==2">{{$t('acapplyList.no')}}</span>
						<span class="" v-if="scope.row.status==3">{{$t('acapplyList.close')}}</span>
					</template>
				</el-table-column>
				
				
				<el-table-column align="center" width="180" prop="username" :label="$t('acapplyList.account')">
				</el-table-column>
				

				
				<el-table-column align="center" width="180" prop="create_time" :label="$t('acapplyList.time')">
				</el-table-column>
				
				<el-table-column align="center" width="100" prop="remark" :label="$t('acapplyList.remark')">
				</el-table-column>
				
				<el-table-column align="center" width="180" prop="update_time" :label="$t('acapplyList.uptime')">
				</el-table-column>
				
			
				
				
		
				<el-table-column width="140" fixed="right" prop="id" align="center" :label="$t('adminList.operation')">
					<template slot-scope="scope">
						<el-button-group>
							<el-button :disabled="scope.row.status!=0" @click="getToUser(scope.row.id)" v-auth="'apply'+auth_val" size="mini" plain type="success">{{$t('accountList.fp')}}</el-button>
							<el-button :disabled="scope.row.status!=0" size="mini" plain type="primary" v-auth="'apply'+auth_val" @click="openModel(scope.row)">{{$t('acapplyList.no')}}</el-button>
							
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>



		<el-footer
		  class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		  :style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		  >
		   <div style="flex: 1;" class="px-2">
		    <el-pagination
		    :current-page="page.current"
		    :page-sizes="page.sizes"
		    :page-size="page.size"
		    @size-change="handleSizeChange"
		    @current-change="handleCurrentChange"
		    background
		    :layout="layout.is_phone ? 'total, prev, pager, next, jumper' : 'total, prev, pager, next, sizes, jumper'"
		    :total="page.total"
		    />
		   </div>
		  </el-footer>

		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('acapplyList.notitle') : $t('accountList.addAccount')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
			
				
				<el-form-item :label="$t('acapplyList.remark')" prop="remark">
					<el-input v-model="form.remark" :placeholder="$t('acapplyList.remark')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				
				
				
				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="submit">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				cloud_id:1,
				createModel: false,
				editIndex: -1,
				
				//搜索數据
				from: {
					name: '',
					username:'',
					status:-1,
					get_status:-1,
					cloud_id:-1,
					time:[],
				},
				auth_val: 'Pay',

				preUrl: "data/accountApplyList", //列表地址
				delAllUrl: "data/delAccountApplyAll", //批量删除地址
				delUrl: "data/delAccountApply", //删除單条地址
				addUrl: "data/addAccountApply", //添加/修改地址
				editStatusUrl:"data/editStatusAccountApply",//修改狀態地址
				agentData:[],
				tableData: [],
				form: {},
				rules: {
					remark: [{
						required: true,
						message: this.$t('acapplyList.inpRemark'),
						trigger: 'blur',
					}],
					
				},
				rule_list: [],
				check_img_list:[]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			//this.commonList('cloud');
		},
		methods: {
			getToUser(id){
				this.layout.getModel = true
				this.layout.getModelType = 2
				this.layout.getModelTypeId = id
			},
			checkLog(id){
				this.layout.logModel = true
				this.layout.logID = id
			},
			changePassShow(item){
				item.showPass = item.showPass==1?0:1
			},
			changeMoneyType(e){
				if(e==1){
					this.form.money = 0
				}
				//console.log(e)
			},
			//提交
			submit() {
				// if (this.form.password != this.form.password2) {
				// 	this.$message({
				// 		message: this.$t('adminList.differentPasswords'),
				// 		type: 'error'
				// 	});
				// 	return
				// }
				this.$refs.form.validate(res => {
					// if(!this.form.headUrl){
					// 	this.$message.error(this.$t('adminList.upProfile'));
					// 	return false
					// }
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form,true)
						// 關閉模态框
					}
				})
			},

			// 打开模态框
			openModel(e = false) {
				
		
				// 增加
				
				if (!e) {
					return false;
				} else {
					// 修改
					this.form = {
						id:e.id,
						remark:''
					}
					this.editIndex = e.id
				}
				
				// 打开dialog
				this.createModel = true
			},
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.agentData = list
					console.log(res)
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
			beforeAvatarUpload(file) {
							const isJPG = file.type === 'image/jpeg';
							const isLt2M = file.size / 1024 / 1024 < 2;
					
							// if (!isJPG) {
							//   this.$message.error('上傳头像图片只能是 JPG 格式!');
							// }
							// if (!isLt2M) {
							//   this.$message.error('上傳头像图片大小不能超過 2MB!');
							// }
							return isJPG && isLt2M;
			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					username:'',
					status:-1,
					get_status:-1,
					cloud_id:-1,
					time:[],
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
.custom-dialog {
  z-index: 3000!important; /* 设置更高的 z-index */
}
</style>
